module.exports = "/_next/static/images/46bbaa10123bbe2a1467fed3da2272e6-check.svg";